export default __webpack_public_path__ + "static/Bullish-1945544c02c8d3bad31f26b196a416aa.png";